jQuery(document).ready(function($) {
  $(window).on('load', function(){
    $('body').addClass('loaded');
  });
  // Start videos playing if possible
  if ($(".hero .video").length) {
    $(".hero .video video").each(function() {
      var $this = $(this);
      window.setTimeout(function($) {
        $this.get(0).play();
      }, 1000);

      var promise = $(this)
        .get(0)
        .play();
      if (promise !== undefined) {
        promise
          .then(_ => {
            //console.log('playing');
            $(this)
              .parent(".video")
              .addClass("is-playing");
          })
          .catch(error => {
            console.log("cant play video");
            //$(this).append('<h1>error</h1>');
          });
      }
    });
  }

  var iframe = document.querySelector(".modal__video iframe");
  var player = new Vimeo.Player(iframe);

  $("html").on("click", ".modal__video", function(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log("close");
    $("html").removeClass("modal-open");
    player
      .pause()
      .then(function() {})
      .catch(function(error) {});
  });

  $('a[href="#close-modal"]').on("click", function(e) {
    e.preventDefault();
    console.log("close");
    $("html").removeClass("modal-open");
    player
      .pause()
      .then(function() {})
      .catch(function(error) {});
  });

  $('a[href="#play-video"]').on("click", function(e) {
    e.preventDefault();
    $("html").addClass("modal-open");
    player
      .play()
      .then(function() {})
      .catch(function(error) {});
  });

  if ($(".location-carousel").length) {
    // only location page

    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var offset =
        $(".location-carousel").offset().top - $(window).height() / 4; // location images will be 25% from top.

      if (scroll >= offset) {
        $(".enquire-button").addClass("anim-attention");
      }

      //if (scroll <= offset) {
      //    $(".enquire-button").removeClass("anim-attention");
      //}

      var mobileButton =
        $(".enquire-button-mobile").offset().top - $(window).height() / 1.334; // location images will be 75% from top.
      if (scroll >= mobileButton) {
        $(".enquire-button-mobile").addClass("anim-attention");
      }
    });
  }

  if ($("#home-path").length) {
    var debounce_timer;

    $(window).scroll(function() {
      if (debounce_timer) {
        window.clearTimeout(debounce_timer);
      }

      debounce_timer = window.setTimeout(function() {
        drawLine($(".journey-line svg"), document.getElementById("home-path"));
      }, 10);
    });

    // init the line length
    drawLine($(".journey-line svg"), document.getElementById("home-path"));

    //draw the line
    function drawLine(container, line) {
      var pathLength = line.getTotalLength(),
        maxScrollTop = $(document).height() - $(window).height() * 2,
        percentDone = $(window).scrollTop() / maxScrollTop,
        length = percentDone * pathLength;
      line.style.strokeDasharray = [length, pathLength].join(" ");
    }
  }

  // Scroll Reveal
  // Changing the defaults
  window.sr = ScrollReveal({
    origin: "bottom",
    distance: 0,
    duration: 750,
    delay: 250,
    rotate: {
      x: 0,
      y: 0,
      z: 0
    },
    opacity: 0.01,
    scale: 1,
    easing: "cubic-bezier(.35,0,.17,1)",
    container: window.document.documentElement,
    mobile: true,
    reset: false,
    useDelay: "always",
    viewFactor: 0.2,
    viewOffset: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    beforeReveal: function(domEl) {},
    beforeReset: function(domEl) {},
    afterReveal: function(domEl) {},
    afterReset: function(domEl) {}
  });

  // Customizing a reveal set

  if ($(".sr--fadein").length) {
    sr.reveal(".sr--fadein", {});
  }

  if ($(".sr--fadein-up").length) {
    sr.reveal(".sr--fadein-up", {
      distance: "30px"
    });
  }

  if ($(".sr--fadein-delay").length) {
    sr.reveal(".sr--fadein-delay", {
      delay: 750
    });
  }

  if ($(".sr--fadein-up-seq").length) {
    sr.reveal(".sr--fadein-up-seq", {}, 250);
  }

  // Waypoints

  if ($("#sticky-trigger").length) {
    var waypointHeader = new Waypoint({
      element: document.getElementById("sticky-trigger"),
      handler: function(direction) {
        if (direction === "down") {
          $("#sticky-header").addClass("show");
          //console.log('add');
        } else if (direction === "up") {
          $("#sticky-header").removeClass("show");
          //console.log('remove');
        }
      }
      //offset: '-100%'
    });
  }

  // carousel Locations

  var $carousel = $(".carousel").flickity({
    imagesLoaded: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    dragThreshold: 10,
    draggable: true,
    cellAlign: "left",
    autoPlay: 5000,
    pauseAutoPlayOnHover: true
  });

  $carousel;

  var $carouselNav = $(".carousel-nav").flickity({
    imagesLoaded: true,
    asNavFor: ".carousel",
    contain: true,
    pageDots: false,
    prevNextButtons: false
  });

  $carouselNav;

  // next
  $(".carousel__arrows .arrows__prev").on("click", function(e) {
    e.preventDefault();
    $carousel.flickity("previous");
  });

  $(".carousel__arrows .arrows__next").on("click", function(e) {
    e.preventDefault();
    $carousel.flickity("next");
  });

  //

  var $heroGallery = $(".gallery").flickity({
    imagesLoaded: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    dragThreshold: 10,
    draggable: false,
    autoPlay: 5000,
    pauseAutoPlayOnHover: false,
    selectedAttraction: 1,
    friction: 1
  });

  $heroGallery;

  // next
  $(".hero__arrows .arrows__prev").on("click", function(e) {
    e.preventDefault();
    $heroGallery.flickity("previous");
  });

  $(".hero__arrows .arrows__next").on("click", function(e) {
    e.preventDefault();
    $heroGallery.flickity("next");
  });

  // Set hero slide height via javascript to avoid a chrome issue that expands, when browser height changes on scroll.
  $(".hero .gallery img").css("height", $(window).height());

  var $whycarousel = $(".why-gallery").flickity({
    imagesLoaded: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    dragThreshold: 20,
    draggable: false
  });

  $whycarousel;

  // next
  $(".why-gallery__arrows .arrows__prev").on("click", function(e) {
    e.preventDefault();
    $whycarousel.flickity("previous");
  });

  $(".why-gallery__arrows .arrows__next").on("click", function(e) {
    e.preventDefault();
    $whycarousel.flickity("next");
  });

  var $memberslider = $(".feat-member-slider").flickity({
    imagesLoaded: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    cellSelector: ".feat-member",
    dragThreshold: 20,
    draggable: false
  });

  $memberslider;

  // next
  $(".feat-member-arrows__prev").on("click", function(e) {
    e.preventDefault();
    $memberslider.flickity("previous");
  });

  $(".feat-member-arrows__next").on("click", function(e) {
    e.preventDefault();
    $memberslider.flickity("next");
  });

  $(".nav-open").click(function(e) {
    e.preventDefault();
    //$('.nav-open').addClass('active');
    $("#main-nav nav").addClass("active");
  });

  $(".nav-close").click(function(e) {
    e.preventDefault();
    //$('.nav-open').removeClass('active');
    $("#main-nav nav").removeClass("active");
  });

  $("li.menu-item-has-children > a").click(function(e) {
    e.preventDefault();
    //$('.nav-open').addClass('active');
    $(this)
      .next("ul")
      .toggleClass("active");
  });

  $(".hero__scroll").on("click", function(e) {
    e.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $("#sticky-trigger").offset().top
      },
      500,
      function() {}
    );

    sr.sync();
  });

  // Why Navigation

  $(".why-nav a").on("click", function(e) {
    e.preventDefault();
    var tab = $(this).attr("data-tab");

    $("html, body").animate(
      {
        scrollTop: $("#sticky-trigger").offset().top
      },
      500,
      function() {
        // Add active class to button
        $(".why-nav a").removeClass("active");
        $("[data-tab=" + tab + "]").addClass("active");

        // Add active class to the tab section
        $(".why-tab").removeClass("active");
        $(tab).addClass("active");
      }
    );

    sr.sync();
  });

  // Check Hash ID
  var hashID = "#" + window.location.hash.substring(1);

  if (window.location.hash) {
    //If we have a hash filter by it, if not don't try

    var tab = hashID;

    $("html, body").animate(
      {
        scrollTop: $("#sticky-trigger").offset().top
      },
      500,
      function() {
        // Add active class to button
        $(".why-nav a").removeClass("active");
        $(this).addClass("active");

        // Add active class to the tab section
        $(".why-tab").removeClass("active");
        $(hashID).addClass("active");
      }
    );

    sr.sync();
  }

  // Enquire Form

  $('a[href="#enquire"]').on("click", function(e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: 0
      },
      500,
      function() {
        $(".enquire-form").addClass("active");
        $(".hire-form").removeClass("active"); // close other form if open
      }
    );
  });

  $("#enquire-close").on("click", function(e) {
    e.preventDefault();
    $(".enquire-form").removeClass("active");
  });

  // Hire Form

  $('a[href="#hire"]').on("click", function(e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: 0
      },
      500,
      function() {
        $(".hire-form").addClass("active");
        $(".enquire-form").removeClass("active"); // close other form if open
      }
    );
  });

  $("#hire-close").on("click", function(e) {
    e.preventDefault();
    $(".hire-form").removeClass("active");
  });

  // Isotope

  var $grid = $(".item-grid").isotope({
    itemSelector: ".item",
    layoutMode: "fitRows",
    stagger: 50,
    transitionDuration: 500
  });

  // layout Isotope after each image loads
  $grid.imagesLoaded().progress(function() {
    $grid.isotope("layout");
    //console.log('image loaded');
  });

  $grid.isotope("layout");

  // bind filter on select change
  $(".filters-select").on("change", function() {
    // get filter value from option value
    var filterValue = this.value;
    // use filterFn if matches value
    //filterValue = filterFns[ filterValue ] || filterValue;
    $grid.isotope({
      filter: filterValue
    });
  });
});
